module.exports = require('./helpers/bundle-url').getBundleURL('1KTPu') + "logo.7718c6df.svg";